import { Moon, Sun, Monitor } from "lucide-react";
import { useTheme } from "next-themes";

const modes = ["light", "dark", "system"] as const;
const icons = { light: Sun, dark: Moon, system: Monitor };
const labels = { light: "Light", dark: "Dark", system: "System" };

export function ThemeToggle() {
  const { theme, setTheme } = useTheme();

  return (
    <div className="flex w-full items-center gap-1 rounded-md border border-border p-0.5">
      {modes.map((mode) => {
        const Icon = icons[mode];
        const isActive = theme === mode;
        return (
          <button
            key={mode}
            onClick={() => setTheme(mode)}
            className={`flex flex-1 items-center justify-center gap-1.5 rounded px-2 py-1 text-xs transition-colors ${
              isActive
                ? "bg-accent text-accent-foreground font-medium"
                : "text-muted-foreground hover:text-foreground"
            }`}
            title={labels[mode]}
          >
            <Icon className="h-3.5 w-3.5" />
            <span>{labels[mode]}</span>
          </button>
        );
      })}
    </div>
  );
}
